<template>
  <div>
    <div
        v-if="notificationLoading"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      "
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10" v-else>
      <v-layout row wrap style="padding: 0px 0px 0px 0px; align-content: center; align-items: center;">
        <v-flex xm12 sm12 md12 lg9>
          <v-expansion-panel class="mb-4">
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Filters</div>
              </template>
              <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;"
                        class="index_header">
                <v-flex sm4 md2 lg2>
                  <v-checkbox
                      label="Draft"
                      :value="filters.Draft"
                      row
                      v-model="filters.Draft"
                      @change="filter($event)"
                      class="request_checkbox"
                      :color="'black'"
                  ></v-checkbox>
                </v-flex>
                <v-flex sm4 md2 lg2 style="margin-right: 30px;">
                  <v-checkbox
                      label="Published"
                      :value="filters.Published"
                      v-model="filters.Published"
                      @change="filterPublished($event)"
                      class="request_checkbox"
                      :color="'black'"
                  ></v-checkbox>
                </v-flex>

                <v-flex sm4 md2 lg2 style="margin-right: 20px;">
<!--                  <v-checkbox-->
<!--                      label="Archived"-->
<!--                      :value="filters.Archived"-->
<!--                      v-model="filters.Archived"-->
<!--                      @change="filterArchived($event)"-->
<!--                      class="request_checkbox"-->
<!--                      :color="'black'"-->
<!--                  ></v-checkbox>-->
                </v-flex>

<!--                <v-flex sm4 md4 lg2 style="margin-right: 30px;">-->
<!--                  <v-checkbox-->
<!--                      label="Is-Pinned"-->
<!--                      :value="filters.is_pinned"-->
<!--                      v-model="filters.is_pinned"-->
<!--                      @change="filterIsPinned($event)"-->
<!--                      class="request_checkbox"-->
<!--                      :color="'black'"-->
<!--                  ></v-checkbox>-->
<!--                </v-flex>-->

                <v-flex sm12 md6 lg4 style="margin-top: 13px;">
                  <v-autocomplete
                      v-model="filters.title"
                      :items="title_list"
                      placeholder="Search By Title"
                      item-value="title"
                      item-text="title"
                      clearable solo flat
                      :search-input.sync="search_title"
                      @change="searchByTitle()"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>


        <v-flex xs12 sm12 md12 lg3>
          <v-flex xs12 sm12 md12 lg12 style="display: flex; justify-content: center; padding-bottom: 27px;">
            <v-btn slot="activator" class="white--text add_announcement text-xs-center" style="padding: 22px;">
              <router-link to="/announcements/create" class="white--text">
                <v-icon color="#bbbbc6" class="white--text mr-2">edit
                </v-icon
                >
                Create Service Alert
              </router-link
              >
            </v-btn>
          </v-flex>
        </v-flex>

      </v-layout>


      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              v-model="selected"
              :items="announcement_list"
              item-key="id"
              :pagination.sync="pagination"
              :loading="loaders.office_list_loader"
              select-all
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]"
          >
            <template v-slot:headers="props">
              <tr>
                <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="[
                    header.sortable !== false ? 'column sortable' : '',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                    @click="changeSort(header)"
                >
                  {{ header.text }}
                  <v-icon small v-if="header.sortable !== false"
                  >arrow_upward
                  </v-icon
                  >
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
<!--              <td>-->
<!--                <v-checkbox-->
<!--                    v-model="props.selected"-->
<!--                    primary-->
<!--                    hide-details-->
<!--                    :readonly="is_selected_all"-->
<!--                ></v-checkbox>-->
<!--              </td>-->
<!--              <td style="padding: 0 10px">-->
<!--                <v-checkbox-->
<!--                    :on-icon="'star'"-->
<!--                    :off-icon="'star'"-->
<!--                    style="width:20px; height:20px"-->
<!--                    v-model="props.item.pin_till_date"-->
<!--                    :color="props.item.pin_till ? 'orange': 'red'"-->
<!--                    @change="update_announcement_date_pinned_till_dialog = true,-->
<!--                    announcement_id = props.item.id, pinned_till_date = props.item.pin_till"-->
<!--                >-->
<!--                  &lt;!&ndash;                  :color="(props.item.pin_till != null) ? 'orange' : 'red'"&ndash;&gt;-->
<!--                </v-checkbox>-->
<!--              </td>-->
<!--              <td v-if="props.item.city_id">-->
<!--                <span v-if="props.item.city_id == 1"> {{ "Mumbai" }} </span>-->
<!--                <span v-else-if="props.item.city_id == 2"> {{ "Pune" }} </span>-->
<!--                <span v-else-if="props.item.city_id == 3"> {{ "Chennai" }} </span>-->
<!--                <span v-else-if="props.item.city_id == 4"> {{ "Kochi" }} </span>-->
<!--                <span v-else-if="props.item.city_id == 5"> {{ "Kanpur" }} </span>-->
<!--                <span v-else>{{ props.item.city_id }}</span>-->
<!--              </td>-->
<!--              <td v-else>-->
<!--                {{ " - " }}-->
<!--              </td>-->



              <td>
                <router-link :to="{name:'announcementDetail',params:{id:props.item.id } }">
                  <span v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md">{{ props.item.title.substring(0,40)+"..."}}</span>
                  <span v-else>{{ props.item.title }}</span>

                </router-link>
              </td>
              <td v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm || $vuetify.breakpoint.md">
                {{ props.item.description.substring(0,40)+"..."}}
              </td>
              <td v-else>
                {{ props.item.description }}
              </td>

              <td v-if="props.item">
                {{props.item.city_name}}
              </td>
              <td v-else> {{ " - "}} </td>

              <td v-if="props.item.status" style="text-transform: capitalize;">
              <span><v-chip color="#FFEDAA" text-color="#935E0D" v-if="props.item.status == 'draft'">{{
                  props.item.status }}</v-chip>
              <v-chip color="#C8E6C9" text-color="#1B5E20"
                      v-else-if="props.item.status == 'published'">{{
                  props.item.status }}</v-chip>
                <v-chip color="#d2b5a1" text-color="#794936" v-else-if="props.item.status == 'archived'">{{
                    props.item.status }}</v-chip>
              </span>
              </td>

              <td>
                {{ (props.item.updated_at) | appDateTimeFormat }}

              </td>
            </template>


          </v-data-table>
        </v-flex>
      </v-layout>
      <!-- Delete Resource dialog box -->
      <v-dialog
          v-model="delete_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete the announcement?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="delete_model = !delete_model"
              >Cancel
              </v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>


      <v-dialog
          v-model="update_announcement_date_pinned_till_dialog"
          scrollable
          max-width="500px"
      >
        <v-form
            @submit.prevent="validateBeforeSubmit('updatePinnedDate')"
            data-vv-scope="updatePinnedDate"
            id="updatePinnedDate"
            ref="form"
            style="width: 100%"
        >
          <v-card style="width: 100%">
            <v-card-title primary-title
            ><h4 class="heading_text">Pinned Till </h4></v-card-title
            >
            <v-card-text style="padding-top: 0px">
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <label>Select Date : </label>
                  <v-menu
                      ref="open"
                      :close-on-content-click="false"
                      v-model="open"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        v-model="pinned_till_date"
                        placeholder="Select Date"
                        solo flat clearable
                    ></v-text-field>
                    <v-date-picker v-model="pinned_till_date" header-color="primary" :min="min_pinned_date"
                                   @input="open = false"></v-date-picker>
                  </v-menu>

                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  type="button"
                  color="error"
                  small
                  flat
                  underline
                  @click="update_announcement_date_pinned_till_dialog = false, getList()"
              >Cancel
              </v-btn>
              <v-btn
                  type="submit"
                  color="primary"
                  small
                  :loading="pinned_till_loader"
              >Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout"
      >
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  created() {
  },
  computed: {
    ...mapGetters({
      office_location: "get_office_location",
    }),
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
    search_title: {
      handler(newVal) {
        if (newVal != null && newVal.length > 3) {
          this.getTitleList(newVal);
        }
      },
    },
    "filters.title": {
      handler(value) {
        if (value == undefined) {
          this.filters.title = "";
          this.getList();
        }
      },
    },
  },
  methods: {
    searchByTitle() {
      this.getList();
    },
    filter(value) {
      this.filters.Published = false;
      this.filters.Archived = false;
      this.filters.Draft = value;
      this.filters.is_pinned = false;
      this.getList();
    },
    filterPublished(value) {
      this.filters.Draft = false;
      this.filters.Archived = false;
      this.filters.Published = value;
      this.filters.is_pinned = false;

      this.getList();
    },
    filterArchived(value) {
      this.filters.Published = false;
      this.filters.Draft = false;
      this.filters.Archived = value;
      this.filters.is_pinned = false;

      this.getList();
    },
    // filterIsPinned(value) {
    //   this.filters.Published = false;
    //   this.filters.Draft = false;
    //   this.filters.Archived = false;
    //   this.filters.is_pinned = value;
    //   this.getList();
    // },

    getList: function () {
      this.loaders.office_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/announcement-list`, {
            params: this.pagination,
            headers: this.$headers,
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.announcement_list = response.data.announcements.data;

              this.announcement_list.forEach((element) => {
                element.pin_till_date = element.pin_till
              });


              if (this.cityList && this.cityList.length > 0) {
                this.announcement_list.forEach((commute) => {
                  let city = this.cityList.find(item => item.id == commute.city_id);

                  if (city) {
                    commute.city_name = city.name;
                  }
                });
              }
              this.total_items = response.data.announcements.total;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar.message = true;
            this.snackbar.message = "Something went wrong";
          })
          .finally(() => {
            {
              this.loaders.office_list_loader = false;
            }
          });

      this.is_loading = false;
    },

    clearFilter: function (filter, key) {
      this.filter_chips[key] = this.filters[key] = "";
      this.filterList();
    },
    resetFilter() {
      this.$router.replace({
        name: "announcements",
        query: {},
      });
      this.getList();
      this.resetFiltersParameters();
      this.is_filtered = false;
      this.filter_dialog_box = false;
      // this.snackbar.message = "Filter Reset.";
      // this.snackbar.display = true;
    },
    resetFiltersParameters: function () {
      for (var key in this.filters) {
        this.filters[key] = "";
        this.filter_chips[key] = "";
      }
    },
    applyFiltersOnLoad: function () {
      this.filters.name = this.$route.query.name;
      this.filters.address = this.$route.query.address;
      this.displayFilterChips(this.filters);
    },
    displayFilterChips: function (filters) {
      if (this.$route.query.filters) {
        this.filter_chips.name = filters.name;
        this.filter_chips.address = filters.address;
        this.is_filtered = true;
      }
    },
    validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.announcement_list.slice();
      }
      this.is_selected_all = false;
    },
    togglePages() {
      this.is_selected_all = !this.is_selected_all;
      if (this.is_selected_all) {
        this.selectAll();
        this.all_selected_items = [];
      } else {
        this.selected = [];
      }
    },
    selectAll() {
      this.selected = this.announcement_list.slice();
    },

    pageSelect() {
      this.toggleAll();
    },
    deselectAll() {
      this.selected = [];
      this.is_selected_all = false;
      this.all_selected_items = [];
    },
    deleteAnnouncement: function (item) {
      this.announcement_item = item;
      this.delete_model = true;
    },
    confirmDelete: function () {
      this.notificationLoading = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/delete-announcement`,
              {announcement_id: this.announcement_item.id},
              {headers: this.$headers}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.notificationLoading = false;
              this.delete_model = false;
              this.getList();
              this.snackbar.message = response.data.message;
              this.snackbar.display = true;

            }
          })
          .catch((error) => {
          })
          .finally(() => {
          });
    },
    getTitleList: function (newVal) {
      this.loaders.office_list_loader = true;
      axios
          .get(
              `${process.env.VUE_APP_API_URL}/api/v1/announcement-title-filter`,
              {headers: this.$headers, params: {searched_title: newVal}}
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.title_list = response.data.titles;
            }
          })
          .catch((error) => {
            console.log(error);
            this.snackbar.message = "Error Occurred";
            this.snackbar.display = true;
          })
          .finally(() => {
            {
              this.loaders.office_list_loader = false;
            }
          });
      this.is_loading = false;
    },
    updatePinnedDate() {
      this.pinned_till_loader = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/update-announcement-pinned_till_date`,
              {pinned_till_date: this.pinned_till_date, id: this.announcement_id},
              {headers: this.$headers}
          ).then((response) => {

        if (response.data.status == 1) {
          this.update_announcement_date_pinned_till_dialog = false;
          this.pinned_till_loader = false;
          this.getList();
        } else if (response.data.status == 0) {
          this.update_announcement_date_pinned_till_dialog = false;
          this.pinned_till_loader = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        this.update_announcement_date_pinned_till_dialog = false;
        this.pinned_till_loader = false;
        this.snackbar.message = "Error Occurred";
        this.snackbar.display = true;
      })
    },
    getCityList(){
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-city-list`, {headers: this.$headers})
          .then(response => {
            if (response.data.status == 1) {
              this.cityList = response.data.data;
              this.cityList.push({'id' : 0, 'name': "ALL" })
            }
          });
    }
  },
  data: () => {
    return {
      announcement_item: {},
      title_list: [],
      search_title: "",
      delete_model: false,
      is_selected_all: false,
      all_selected_items: [],
      selected: [],
      is_filtered: false,
      notificationLoading: false,
      filter_key_count: -1,
      pagination: {sortBy: "created_at", descending: false, rowsPerPage: 10},
      filters: {
        status: "",
        title: "",
        Draft: false,
        Published: false,
        Archived: false,
        is_pinned: false
      },
      filter_chips: {
        name: "",
        address: "",
      },
      filter_dialog_box: false,
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      total_items: 0,
      headers: [

        {
          text: "Title",
          value: "title",
          align: "left",
          sortable: false,
        },
        {
          text: "Description",
          value: "description",
          align: "left",
          sortable: false,
        },
        {
          text: "City Name",
          value: "city_name",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          value: "status",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: false,
        },
      ],
      announcement_list: [],
      announcement_list1: {
        id: '',

      },
      add_new_office_model: false,
      new_office: {
        name: "",
      },
      loaders: {
        office_list_loader: false,
        new_office_submit_loader: false,
      },
      auth_user: {
        roles: [{}],
      },
      update_announcement_date_pinned_till_dialog: false,
      pinned_till_loader: false,
      pinned_till_date: '',
      min_pinned_date: '',
      announcement_id: '',
      open: false,
      cityList: [],
    };
  },
  mounted() {
    this.getCityList();
    this.getList();
    this.applyFiltersOnLoad();
    this.auth_user = this.$store.getters.get_user;
    this.min_pinned_date = moment().format("YYYY-MM-DD").toString();
    // console.log(this.auth_user)
  },
};
</script>


<style>
.add_announcement {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}

.accent--text {
  color: #00a63f;
}

.abcd {
  color: #ef06eb !important;
}

.pqrs {
  color: #a68a00 !important;
}
</style>

